import { Skeleton, SkeletonText, Stack } from '@chakra-ui/react';

const AboutUsSkeleton = () => {
  return (
    <Stack className='about-us about-us--skeleton' spacing={4}>
      <Skeleton height='40px' width='220px' />
      <SkeletonText noOfLines={8} spacing={4} skeletonHeight='4' />
    </Stack>
  );
};

export default AboutUsSkeleton;
